// SearchInput.jsx
import React from "react";
import PropTypes from "prop-types";
import Input from "../Input/Input"; // ajusta ruta real
import Button from "../Button/Button"; // tu botón
import "./search.css";

const SearchInput = ({
    value,
    onChange, // espera recibir el string nuevo
    onClear,
    label,
    typeLabel,
    placeholder,
    showClear = true,
    name = "search",
}) => {
    // normaliza lo que venga de Input: evento o string
    const handleInputChange = (incoming) => {
        let newVal = "";
        if (incoming && typeof incoming === "object") {
            if (incoming.target && typeof incoming.target.value === "string") {
                newVal = incoming.target.value;
            }
        } else if (typeof incoming === "string") {
            newVal = incoming;
        }
        onChange(newVal);
    };

    return (
        <div className="search-container">
            <div className="search-group">
                {label && <label htmlFor={name}>{label}</label>}
                {typeLabel && <span className="input-type-badge">{typeLabel}</span>}
                <div style={{ position: "relative", display: "flex", alignItems: "center", gap: 8 }}>
                    <Input
                        name={name}
                        value={value}
                        onChange={handleInputChange}
                        placeholder={placeholder}
                        variant="Simple"
                        autoFocus={false}
                        handleKeyDown={(e) => {
                            if (e.key === "Escape") onClear();
                        }}
                        classNames="search-input"
                    />
                    {showClear && value && (
                        <div className="clear-wrapper" style={{ flexShrink: 0 }}>
                            <Button
                                text="Limpiar"
                                color="red"
                                fill
                                action={onClear}
                                classNames="btn-clear"
                                type="button"
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

SearchInput.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired, // recibe string
    onClear: PropTypes.func.isRequired,
    label: PropTypes.string,
    typeLabel: PropTypes.string,
    placeholder: PropTypes.string,
    showClear: PropTypes.bool,
    name: PropTypes.string,
};

export default SearchInput;
